import { createApp, reactive, nextTick } from 'vue'

import ToastComponent from './ImoToast.vue' // Substitua pelo seu componente de Toast
import { registerToast } from './toastHelper'

const ToastPlugin = {
  install(app, options = {}) {
    const maxToasts = options.maxToasts || 5 // Limite de toasts simultâneos
    const toasts = reactive([]) // Gerenciar lista de toasts dinamicamente

    // Função para mostrar um novo toast
    async function show(message, toastOptions = {}) {
      if (toasts.length >= maxToasts) {
        return
      }
      const container = document.createElement('div') // Cria um contêiner no DOM
      document.body.appendChild(container)

      const ToastInstance = createApp(ToastComponent, {
        ...toastOptions,
        message, // Passa a mensagem como prop
        onDismiss: () => {
          removeToast(vm) // Captura o evento de dismiss
        },
      })

      const vm = ToastInstance.mount(container)

      toasts.push(vm)

      // Aguarda próximo tick para garantir que o DOM está pronto
      await nextTick()

      // Chama método exposto para mostrar o toast
      vm.show()

      await nextTick()
      updateToastPositions()
    }

    // Função para remover o toast
    function removeToast(toast) {
      const index = toasts.indexOf(toast)
      if (index !== -1) {
        toasts.splice(index, 1) // Remove da lista
        document.body.removeChild(toast.$el.parentNode) // Remove do DOM
        updateToastPositions()
      }
    }

    // Função para atualizar as posições dos toasts
    function updateToastPositions() {
      toasts.forEach((toast, index) => {
        if (!toast.$el) return

        const position = toast.position || 'top-right' // Posição padrão
        const styles = {}

        if (position.includes('top')) {
          styles.top = `${34 + index * 80}px`
        } else if (position.includes('bottom')) {
          styles.bottom = `${64 + index * 80}px`
        }

        if (position.includes('right')) {
          styles.right = '16px'
        } else if (position.includes('center')) {
          styles.left = '50%'
          styles.transform = 'translateX(-50%)'
        }

        Object.assign(toast.$el.style, styles) // Aplica os estilos dinâmicos
      })
    }

    // Global
    registerToast(show)

    // Adiciona o plugin globalmente
    app.config.globalProperties.$imoToast = {
      show,
    }
  },
}

export default ToastPlugin
